import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { Box, Button, Grid, Typography } from "@mui/material";

interface SubstanceStudyCardProps {
    type: string;
    description: string;
    frequency: string | null;
    frequencyQuantity: string;
    handleDeleteClick: any;
    onlyVisual: boolean;
}

const SubstanceStudyCard = ({
    type,
    description,
    frequencyQuantity,
    frequency,
    handleDeleteClick,
    onlyVisual
}: SubstanceStudyCardProps) => (
    <Box
        sx={{
            backgroundColor: '#F3F8F8',
            borderRadius: '8px',
            padding: '16px'
        }}
    >
        <Grid container justifyContent={'space-between'} alignItems={'flex-start'}>
            <Typography variant="subtitle1">{type || '-'}</Typography>
            {!onlyVisual && (
                <Button
                    variant="outlined"
                    sx={{
                        minWidth: 32,
                        minHeight: 32,
                        padding: 0,
                        borderRadius: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: '#D32F2F',
                        borderColor: '#D32F2F',
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    }}
                    onClick={handleDeleteClick}
                >
                    <DeleteIcon sx={{ fontSize: 18 }} />
                </Button>
            )}
        </Grid>
        <Typography variant="body1">{description || '-'}</Typography>
        <Typography variant="body1">{`${frequencyQuantity} - ${frequency}`}</Typography>
    </Box>
);

export { SubstanceStudyCard };
